import { HitData } from 'common/store/common/search/types';
import { ContentItemVersionDataLoaded, FetchContentItemVersionsData } from './types';

export enum TypeKeys {
    FETCH_CONTENT_ITEM_VERSIONS_DATA = 'majorVersionsHeader/FETCH_VERSIONS_DATA',
    CONTENT_ITEM_VERSIONS_DATA_LOADED = 'majorVersionsHeader/VERSIONS_DATA_LOADED'
}

export const fetchContentItemVersionsData = (
    contentItemId: number,
    isFetching?: boolean
): FetchContentItemVersionsData => ({
    type: TypeKeys.FETCH_CONTENT_ITEM_VERSIONS_DATA,
    contentItemId,
    isFetching,
});

export const contentItemVersionsDataLoaded = (
    contentItemId: number,
    data: HitData[],
    isFetching?: boolean,
): ContentItemVersionDataLoaded => ({
    type: TypeKeys.CONTENT_ITEM_VERSIONS_DATA_LOADED,
    contentItemId,
    data,
    isFetching,
});


export type ActionTypes = ContentItemVersionDataLoaded |
FetchContentItemVersionsData
